/**
 * Hook to access the lesson flow context. Throws outside `LessonFlowProvider`,
 * matching `useVisualStep`'s contract
 * (`../../booking/context/VisualStepContext.tsx`).
 *
 * @module lessons/context/useLessonFlow
 */

import { useContext } from 'react';
import { LessonFlowContext, type LessonFlowContextValue } from './LessonFlowContext';

export function useLessonFlow(): LessonFlowContextValue {
  const context = useContext(LessonFlowContext);

  if (!context) {
    throw new Error('useLessonFlow must be used within LessonFlowProvider');
  }

  return context;
}
